export const GET_ONLINE_USER_STATS = 'GET_ONLINE_USER_STATS'
export const GET_ALL_TENANT_STATS = 'GET_ALL_TENANT_STATS'
export const GET_ALL_TENANTS = 'GET_ALL_TENANTS'
